"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var html_to_image_1 = require("html-to-image");
var React = require("react");
var button_component_1 = require("../buttons/button_component");
require("./qr_card.scss");
var QRCodeComponent_1 = require("./QRCodeComponent");
var blobToDataUrl = function (blob) {
    return new Promise(function (resolve, reject) {
        var reader = new FileReader();
        reader.onloadend = function () { return resolve(reader.result); };
        reader.onerror = reject;
        reader.readAsDataURL(blob);
    });
};
var LabQRCard = function (_a) {
    var _b, _c, _d;
    var data = _a.data;
    var captureRef = React.useRef(null);
    var _e = React.useState(require('../../../assets/images/logo.svg')), logoSrc = _e[0], setLogoSrc = _e[1];
    React.useEffect(function () {
        fetch(require('../../../assets/images/logo.svg'))
            .then(function (res) { return res.blob(); })
            .then(blobToDataUrl)
            .then(setLogoSrc)
            .catch(function () { });
    }, []);
    React.useEffect(function () {
        if (!captureRef.current)
            return;
        (0, html_to_image_1.toPng)(captureRef.current, { pixelRatio: 1 }).catch(function () { });
    }, []);
    var handleDownload = function () {
        if (!captureRef.current)
            return;
        (0, html_to_image_1.toPng)(captureRef.current, { pixelRatio: 1 })
            .then(function (dataUrl) {
            var link = document.createElement('a');
            link.download = "lab-qr-".concat(data.lab_code || 'card', ".png");
            link.href = dataUrl;
            link.click();
        })
            .catch(function (err) { return console.error('QR download failed:', err); });
    };
    return (React.createElement("div", { className: "qr-modal-left" },
        React.createElement("div", { className: "qr-card-capture", ref: captureRef },
            React.createElement("div", { className: "qr-blue-section" },
                React.createElement("img", { src: logoSrc, alt: "lpl-logo", className: "qr-logo-img" }),
                React.createElement("p", { className: "qr-scan-label" }, "Scan QR for Lab Handover"),
                React.createElement("div", { className: "qr-code-area" },
                    React.createElement(QRCodeComponent_1.default, { value: String((_b = data === null || data === void 0 ? void 0 : data.Id) !== null && _b !== void 0 ? _b : ''), size: 280 }))),
            React.createElement("div", { className: "qr-info-section" },
                React.createElement("div", { className: "qr-info-row" },
                    React.createElement("span", { className: "qr-info-label" }, "Centre Name :"),
                    React.createElement("span", { className: "qr-info-value" }, (data === null || data === void 0 ? void 0 : data.center_name) || '—')),
                React.createElement("div", { className: "qr-info-row" },
                    React.createElement("span", { className: "qr-info-label" }, "Lab Code :"),
                    React.createElement("span", { className: "qr-info-value" }, (data === null || data === void 0 ? void 0 : data.lab_code) || '—')),
                React.createElement("div", { className: "qr-info-row" },
                    React.createElement("span", { className: "qr-info-label" }, "Address :"),
                    React.createElement("span", { className: "qr-info-value" }, (data === null || data === void 0 ? void 0 : data.center_address) || '—')),
                React.createElement("div", { className: "qr-latlong-row" },
                    React.createElement("div", { className: "qr-info-row" },
                        React.createElement("span", { className: "qr-info-label" }, "Latitude :"),
                        React.createElement("span", { className: "qr-info-value" }, (_c = data === null || data === void 0 ? void 0 : data.latitude) !== null && _c !== void 0 ? _c : '—')),
                    React.createElement("div", { className: "qr-info-row" },
                        React.createElement("span", { className: "qr-info-label" }, "Longitude :"),
                        React.createElement("span", { className: "qr-info-value" }, (_d = data === null || data === void 0 ? void 0 : data.longitude) !== null && _d !== void 0 ? _d : '—'))))),
        React.createElement("div", { className: "qr-download-section" },
            React.createElement(button_component_1.default, { buttonName: "Download QR", color: "blue", endIcon: "icon-import download-icon", onClickHandler: handleDownload }))));
};
exports.default = LabQRCard;
